export default [
  {
    title: 'Bookkeeping',
    landingSummary:
      'Professional bookkeeping services to keep your finances organized and accurate.',
    slug: 'bookkeeping'
  },
  {
    title: 'Tax',
    landingSummary:
      'Strategic tax planning and accurate tax preparation for businesses and individuals.',
    slug: 'tax'
  },
  {
    title: 'Cost Segregation',
    landingSummary:
      'Own real estate? You may qualify to accelerate your depreciation to save money now.',
    slug: 'cost-segregation'
  },
  {
    title: 'R&D Tax Credit',
    landingSummary:
      'An R&D tax credit is complex, but can save you thousands of dollars. Do you qualify?',
    slug: 'rd-tax-credit'
  },
  {
    title: 'Payroll Setup',
    landingSummary: 'Comprehensive payroll setup to handle employee compensation and compliance.',
    slug: 'payroll-setup'
  },
  {
    title: 'After-the-Fact Payroll',
    landingSummary: 'In-house payroll services for business owners who have no other employees.',
    slug: 'kpi'
  }
];
